<template>
  <div>
    <a-text-field
      varName="name"
      varLabel="Tenant Name"
      :varRequired="true"
      :varInitial="tenant.name"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-clipboard-field
      varName="domain_urls[0].domain"
      varLabel="Tenant Domain"
      :varRequired="true"
      :varInitial="domain.domain"
      :formLayout="formLayout"
      :size="size"
      prefix="https://"
      :disabled="true"
      :value='"https://"+domain.domain+"/user/register"'
    />
    <a-switch-field
      varName="domain_urls[0].is_primary"
      varLabel="Primary Domain"
      :varRequired="true"
      :varInitial="domain.is_primary"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: {
    formLayout: String,
    size: String,
    tenant: Object,
    domain: Object
  }
};
</script>